import React from "react";

import classNames from "classnames";

import type { JSX } from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
  isCompact?: boolean;
  isFullWidth?: boolean;
  isNoWrap?: boolean;
  isCentered?: boolean;
  isReversed?: boolean;
  containerClassName?: string;
}

export default function FieldContainer({
  children,
  className,
  isCompact,
  isFullWidth,
  isNoWrap,
  isCentered,
  isReversed,
  containerClassName,
}: Props): JSX.Element {
  const wrapperClassenames = classNames(
    "relative flex flex-col items-start w-full",
    isCompact ? "mb-[0.9375rem]" : "mb-[1.875rem]",
    isFullWidth ? "max-w-auto" : "max-w-screen-md",
    className,
  );

  const containerClassenames = classNames(
    "flex w-full flex-auto",
    isNoWrap ? "flex-nowrap" : "flex-wrap",
    isCentered && "items-center",
    !isCompact && {
      "flex-col md:flex-row gap-[0.78125rem]": !isReversed,
      "flex-col-reverse md:flex-row-reverse gap-[0.78125rem]": isReversed,
    },
    isCompact && {
      "flex-col md:flex-row items-start gap-[0.3125rem]": !isReversed,
      "flex-col-reverse md:flex-row-reverse justify-end gap-[0.78125rem]":
        isReversed,
    },
    containerClassName,
  );

  return (
    <div className={wrapperClassenames}>
      <div className={containerClassenames}>{children}</div>
    </div>
  );
}
